import OutlinedInput from './OutlinedInput';

export default OutlinedInput;
